import React, { useState } from "react";

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
};

const modalStyle = {
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "420px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
};

const starStyle = (active) => ({
    fontSize: "30px",
    cursor: "pointer",
    color: active ? "#f5b301" : "#ddd",
    transition: "color 0.2s",
});

const FinishProjectModal = ({ idProjet, token, onClose, onSuccess }) => {
    const [note, setNote] = useState(0);
    const [hoveredStar, setHoveredStar] = useState(0);
    const [commentaires, setCommentaires] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const apiUrl = process.env.REACT_APP_API_URL;
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (note < 1 || note > 5) {
            setError("Veuillez sélectionner une note entre 1 et 5.");
            return;
        }
        if (!commentaires.trim()) {
            setError("Le commentaire est obligatoire.");
            return;
        }

        try {
            setLoading(true);
            const form = new FormData();
            form.append("idProjet", idProjet);
            form.append("note", note);
            form.append("commentaires", commentaires);

            const res = await fetch(apiUrl+`/api/projects/finish`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.error || "Erreur lors de l’envoi.");
                setLoading(false);
                return;
            }

            onSuccess?.(data);
            onClose();
        } catch (err) {
            setError("Erreur réseau.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={overlayStyle} onClick={onClose}>
            <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                <h3 style={{ marginBottom: "10px", textAlign: "center" }}>
                    ⭐ Terminer le projet
                </h3>

                <p style={{ textAlign: "center", opacity: 0.7 }}>
                    Donnez votre avis sur le prestataire
                </p>

                {/* ⭐ étoiles */}
                <div style={{ display: "flex", justifyContent: "center", gap: "6px", margin: "15px 0" }}>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <span
                            key={i}
                            style={starStyle(i <= (hoveredStar || note))}
                            onClick={() => setNote(i)}
                            onMouseEnter={() => setHoveredStar(i)}
                            onMouseLeave={() => setHoveredStar(0)}
                        >
                            ★
                        </span>
                    ))}
                </div>

                {/* Commentaire */}
                <textarea
                    rows={4}
                    placeholder="Votre commentaire…"
                    value={commentaires}
                    onChange={(e) => setCommentaires(e.target.value)}
                    style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        resize: "none",
                    }}
                />

                {error && (
                    <p style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
                        {error}
                    </p>
                )}

                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: "10px 16px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            background: "#f1f1f1",
                            cursor: "pointer",
                        }}
                        disabled={loading}
                    >
                        Annuler
                    </button>

                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        style={{
                            padding: "10px 16px",
                            borderRadius: "6px",
                            border: "none",
                            background: "#007bff",
                            color: "white",
                            cursor: "pointer",
                        }}
                    >
                        {loading ? "Envoi…" : "Valider"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FinishProjectModal;
